<template>
	<div class="payment-method-container container-padding">
		<v-dialog />
		<payment-chooser @selectPayment="setTempSelection" @addPayment="addPaymentEvent" />
		<transition name="fade" mode="out-in">
			<div v-if="showDoneButton" class="button-container">
				<BaseButton
					title="Done"
					:classNames="['button--modifier']"
					@click.prevent="handleDoneButtonPress" />
			</div>
		</transition>
	</div>
</template>

<script>
	import CheckoutSection from "@/components/checkout/CheckoutSection";
	import PaymentMethodControl from '@/components/checkout/PaymentMethodControl.vue';
	import headerMixin from '@Mixin/headerMixin';
	import navigationMixin from '@Mixin/navigationMixin';
	import paymentMixin from '../../mixins/paymentMixin';

	const PaymentChooserVue = (resolve) => {
		require.ensure([], () => {
			resolve(require('@Checkout/PaymentChooser.vue'));
		});
	};
	export default {
		mixins: [
			headerMixin,
			navigationMixin,
			paymentMixin,
		],
		data() {
			return {
				selectedPayment: null,
				showDoneButton: true,
			}
		},
		components: {
			'payment-chooser': PaymentChooserVue,
			'payment-method-control': PaymentMethodControl,
			'checkout-section': CheckoutSection,
		},
		methods: {
			handleDoneButtonPress() {
				const payment = this.selectedPayment;
				if (!payment) {
					this._navigateToCheckout();
					return;
				}
				const id = payment.id;
				this.setPaymentMethod(payment);
				this.setSelectedPaymentId(id);
				this._navigateToCheckout();
			},
			setTempSelection(payment) {
				this.selectedPayment = payment;
				this.showDoneButton = true;
			},
			addPaymentEvent(isAddPayment) {
				this.showDoneButton = !isAddPayment;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this._noPaymentSelected) {
				this.setPaymentMethod(null);
				next();
				return;
			}
			if (!this.selectedPayment) {
				next();
				return;
			}
			if (this.selectedPayment.id !== this._paymentSelected) {
				const selectedPaymentAccount = this.getSelectedPaymentAccount();
				this.setPaymentMethod(selectedPaymentAccount);
			}
			next();
		},
		mounted() {
			this._setHeaderTitle('Payment Method');
			this._setHeaderItems([
				{
					key: 'back',
					props: {
						route: 'checkout',
					},
				},
				'title',
				'empty',
			]);
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	.container-padding {
		margin: 20px;
		padding-top: 20px;
	}
	.header-centered {
		margin-bottom: 20px;
		font-weight: bolder;
		text-align: center;
	}
	.button-container {
		display: flex;
		justify-content: center;
		margin: 1em;
		padding-top: 2em;
	}
	@include mobile {
		.payment-method-container {
			min-height: 100vh;
			padding-top: $mobileNavigationHeight;
		}
	}
	@include desktop {}
	@include tablet {}
</style>


// WEBPACK FOOTER //
// src/components/checkout/payment/PaymentMethod.vue